import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const ZhijiList = styled.div`
  .year {
    background-color: #fff;
  }
  .year ul {
    list-style: none;
    padding: 10px 20px 10px 20px;
    margin: 0;
  }
  .year li {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    width: 100%;
    padding: 0 10px 0 10px;
    margin-bottom: 10px;
  }
  .year p {
    display: flex;
    justify-content: space-between;
  }
  .center {
    text-align: center;
  }
`;
interface Array1 {
  职级评审通知标题: string;
  发布时间: string;
  status: number;
  uuid: string;
}
export default function RankAdjustment() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const history = useHistory();
  const tabs = [{ title: "晋级管理" }, { title: "调岗或停职轮训" }];
  const [noticeList, setNoticeList] = useState<Array1[]>([]);
  const [notice1List, setNotice1List] = useState<Array1[]>([]);
  const [keyword, setKeyword] = useState<string>();
  const [keyword1, setKeyword1] = useState<string>();
  useEffect(() => {
    instance.get(`/oa/adjust/getNoticeList`).then((resp) => {
      // console.log(resp);
      // console.log(resp.data.Data.data)
      if (resp.data.Status === "1") {
        let arr = resp.data.Data.data;
        let newArr = arr.filter((item: any, index: any) => {
          return item.status === 5;
        });
        console.log(newArr);
        setNoticeList(newArr);
        setNotice1List(newArr);
      }
    });
  }, []);
  //晋级管理搜索
  const searchBarChange = useCallback((keyword) => {
    instance
      .get(`/oa/adjust/getNoticeList?mobileParam=` + keyword)
      .then((resp) => {
        if (resp.data.Status === "1") {
          let arr = resp.data.Data.data;
          let newArr = arr.filter((item: any, index: any) => {
            return item.status === 5;
          });
          setNoticeList(newArr);
        }
      });
  }, []);
  const noSearch = useCallback(() => {
    instance.get(`/oa/adjust/getNoticeList`).then((resp) => {
      if (resp.data.Status === "1") {
        let arr = resp.data.Data.data;
        let newArr = arr.filter((item: any, index: any) => {
          return item.status === 5;
        });
        setNoticeList(newArr);
      }
    });
  }, []);
  //停职调整搜索
  const searchBarChange1 = useCallback((keyword1) => {
    instance
      .get(`/oa/adjust/getNoticeList?mobileParam=` + keyword1)
      .then((resp) => {
        if (resp.data.Status === "1") {
          let arr = resp.data.Data.data;
          let newArr = arr.filter((item: any, index: any) => {
            return item.status === 5;
          });
          setNotice1List(newArr);
        }
      });
  }, []);
  const noSearch1 = useCallback(() => {
    instance.get(`/oa/adjust/getNoticeList`).then((resp) => {
      if (resp.data.Status === "1") {
        let arr = resp.data.Data.data;
        let newArr = arr.filter((item: any, index: any) => {
          return item.status === 5;
        });
        setNotice1List(newArr);
      }
    });
  }, []);
  return (
    <>
      <ZhijiList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(`/hr/index`);
                  history.go(-1);
                }}
              />
            }
          >
            职级调整
          </NavBar>
          <WhiteSpace />
          <Tabs tabs={tabs} initialPage={"t2"}>
            {/* 晋级管理 */}
            <div className="year">
              <SearchBar
                value={keyword}
                onChange={(value) => setKeyword(value)}
                placeholder="请输入搜索年月"
                className="margin"
                onSubmit={() => {
                  searchBarChange(keyword);
                }}
                onCancel={() => {
                  noSearch();
                }}
              />
              <ul>
                {noticeList.map((item) => (
                  <li>
                    <p>
                      <span>{item.职级评审通知标题}</span>
                      <span
                        onClick={() => {
                          window.location.href =
                            "/hr/rankadjustment/promotionmanagement?vsheetId=" +
                            item.uuid;
                        }}
                      >
                        详情&gt;
                      </span>
                    </p>
                    <p>
                      <span>{item.发布时间}</span>
                    </p>
                  </li>
                ))}
                {noticeList.length === 0 && (
                  <div style={{ textAlign: "center", marginTop: 10 }}>
                    <span>暂无数据</span>
                  </div>
                )}
              </ul>
            </div>
            {/* 调岗或停职轮训 */}
            <div className="year">
              <SearchBar
                value={keyword1}
                onChange={(value) => setKeyword1(value)}
                placeholder="请输入搜索年月"
                className="margin"
                onSubmit={() => {
                  searchBarChange1(keyword1);
                }}
                onCancel={() => {
                  noSearch1();
                }}
              />
              <ul>
                {notice1List.map((item) => (
                  <li>
                    <p>
                      <span>{item.职级评审通知标题}</span>
                      <span
                        onClick={() => {
                          window.location.href =
                            "/hr/rankadjustment/suspension?vsheetId=" +
                            item.uuid;
                        }}
                      >
                        详情&gt;
                      </span>
                    </p>
                    <p>
                      <span>{item.发布时间}</span>
                    </p>
                  </li>
                ))}
                {notice1List.length === 0 && (
                  <div style={{ textAlign: "center", marginTop: 10 }}>
                    <span>暂无数据</span>
                  </div>
                )}
              </ul>
            </div>
          </Tabs>
        </div>
      </ZhijiList>
    </>
  );
}
